import React from 'react'

const CtaButton = ({text, href, className}) => (
    <a href={href} className={`cta-button ${className}`}>
        {text}
    </a>
)

CtaButton.defaultProps = {
    className: ""
}

export default CtaButton



// WEBPACK FOOTER //
// ./src/components/CtaButton/index.js